import React from 'react';

import { cn } from '../lib/utils';

export interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  /**
   * Identifies the workflow for accessibility/evidence tooling without
   * exposing record identifiers. Optional for compact forms such as sign-out.
   */
  workflow?: string;
}

/**
 * Canonical semantic form root.
 *
 * This intentionally preserves the native HTML form contract and every
 * caller-supplied attribute. FormShell composes the same root for full-page
 * authoring workflows; this smaller primitive covers compact, auth, search,
 * sign-out and embedded forms that must not inherit full-page chrome.
 */
export const Form = React.forwardRef<HTMLFormElement, FormProps>(
  ({ className, workflow, ...props }, ref) => (
    <form
      ref={ref}
      className={cn('min-w-0', className)}
      data-form-root="true"
      data-form-workflow={workflow}
      {...props}
    />
  ),
);

Form.displayName = 'Form';
